/**
 * Shared utilities for resolving employee custom field values from OpenSearch
 * documents. Used by both programs-table and programs-aggregate-table components.
 */

export const EMPLOYEE_CUSTOM_ALIASES: Record<string, string[]> = {
  employeeBirthDate: ['employeeDob'],
  employeeDateOfBirth: ['employeeDob'],
  employeeBirth: ['employeeDob'],
};

export function camelToSnakeCase(value: string) {
  return value.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`);
}

export function employeeCustomLeafFallbackKey(leaf: string) {
  return leaf.replace(
    /(KeywordAnalyzable|Analyzable|Keyword|Boolean|Integer|Nested|Object|Float|Date|Text)$/,
    ''
  );
}

export function employeeCustomFieldValue(
  customFields: Record<string, unknown> | undefined,
  leaf: string,
  aliases: Record<string, string[]> = EMPLOYEE_CUSTOM_ALIASES
): unknown {
  const strippedLeaf = employeeCustomLeafFallbackKey(leaf);
  const aliasCandidates = [...(aliases[leaf] || []), ...(aliases[strippedLeaf] || [])];

  const candidates = Array.from(new Set([leaf, strippedLeaf, ...aliasCandidates]));

  for (const candidate of candidates) {
    const strippedCandidate = employeeCustomLeafFallbackKey(candidate);
    const keyVariants = Array.from(
      new Set([
        candidate,
        strippedCandidate,
        camelToSnakeCase(candidate),
        camelToSnakeCase(strippedCandidate),
      ])
    );

    for (const key of keyVariants) {
      const value = customFields?.[key];
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
  }

  return undefined;
}
